import { createActionRoute, createGlobalRoute } from '@townsquare/router/create-route';

export const searchRedirectActionRoute = createGlobalRoute(
	createActionRoute({
		exact: true,
		name: 'searchAction',
		path: '/search/:entity',
	}),
);
